var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [
                              _c("h4", [_vm._v(":: Leads Motorwow")]),
                              _vm._v(" "),
                              _c(
                                "b-btn-group",
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.descargar_csv.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Descargar Lista")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.descargar_tiktok_catalog.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Catálogo TikTok")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                { attrs: { to: { name: "BrandListClient" } } },
                                [_vm._v("Clientes por marcas")]
                              ),
                              _vm._v(" » Leads Motorwow:\n                ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Mostrando "),
                            _c("strong", [_vm._v(_vm._s(_vm.leads.length))]),
                            _vm._v(" leads de la campaña Motorwow:")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.leads,
                          fields: _vm.fields,
                          responsive: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(createdAt)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.formatDate(row.item.createdAt)) +
                                    "\n                "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(middleware_status)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant:
                                        row.item.middleware_status === "sent"
                                          ? "success"
                                          : row.item.middleware_status ===
                                            "failed"
                                          ? "danger"
                                          : "warning"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          row.item.middleware_status ||
                                            "pending"
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(salesforce_status)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant:
                                        row.item.salesforce_status === "sent"
                                          ? "success"
                                          : row.item.salesforce_status ===
                                            "failed"
                                          ? "danger"
                                          : "warning"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          row.item.salesforce_status ||
                                            "pending"
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.details(row.item)
                                      }
                                    }
                                  },
                                  [_vm._v("Ver detalle")]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.errors && _vm.errors.length
                        ? _c(
                            "ul",
                            _vm._l(_vm.errors, function(error, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c(
                                    "b-alert",
                                    { attrs: { show: "", variant: "danger" } },
                                    [_vm._v(_vm._s(error.message || error))]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Detalle del Lead",
            size: "lg",
            "ok-only": "",
            "ok-variant": "danger"
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm.selectedLead
            ? _c("b-table", {
                attrs: {
                  items: _vm.selectedLead,
                  fields: _vm.detailFields,
                  responsive: "",
                  striped: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(key)",
                      fn: function(row) {
                        return [_c("strong", [_vm._v(_vm._s(row.item.key))])]
                      }
                    }
                  ],
                  null,
                  false,
                  104332682
                )
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8100f9f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8100f9f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingMotorwowLeads.vue
// module id = null
// module chunks = 